export default "__VITE_ASSET__NiM5sp1V__"